import * as React from 'react'
import styled from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'

import { useControls } from '../hooks/useControls'

import { SelectionCount } from './SelectionCount'
import { Sort } from './Sort'

export function RelativeControls(): React.ReactElement {
  const [isFiltersOpen, setIsFiltersOpen] = useControls()

  plume.hooks.useScrollLock(isFiltersOpen)

  return (
    <Wrapper>
      <plume.Button color="white" onClick={() => setIsFiltersOpen(true)}>
        <plume.glyphs.stroke.Filter size={18} />
        Filtrer
        <SelectionCount />
      </plume.Button>
      <Separator role="presentation" />
      <Sort />
    </Wrapper>
  )
}

const Separator = styled.div`
  width: 2px;
  height: 26px;
  margin: auto;
  background: ${plume.COLORS.GREY_SHADE_5};
`

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  background-color: ${plume.COLORS.PRIMARY_WHITE};

  @media not screen and ${plume.BREAKPOINTS.TABLET} {
    box-shadow: 2px -4px 14px ${plume.COLORS.hexToRgb(plume.COLORS.GREY_SHADE_1, 0.1)};
    position: fixed;
    bottom: 0;
    z-index: 1;
    left: 0;
    right: 0;
  }

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    background-color: transparent;
    justify-content: end;
    margin-bottom: 24px;

    ${Separator} {
      display: none;
    }
  }

  ${plume.Button} {
    position: relative;
    width: 49.6%;
    align-items: center;
    background-color: ${plume.COLORS.PRIMARY_WHITE};
    color: ${plume.COLORS.GREY_SHADE_1};

    ${plume.glyphs.stroke.Filter} {
      margin: 0 6px 0 0;
      color: ${plume.COLORS.GREY_SHADE_7};
    }

    @media screen and ${plume.BREAKPOINTS.TABLET} {
      display: none;
    }
  }
`
